var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEstadoParcial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.65 108.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #b74f6a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m54.33,0C24.32,0,0,24.32,0,54.33s24.32,54.3,54.33,54.3,54.33-24.32,54.33-54.3S84.33,0,54.33,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.92,82.52c0,4.39-3.55,7.91-7.94,7.91s-7.91-3.52-7.91-7.91,3.55-7.94,7.91-7.94,7.94,3.55,7.94,7.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.03,69.18h-8.08c-1.17,0-2.17-.96-2.24-2.16l-2.45-43.04c-.14-2.39,1.13-4.38,2.84-4.38h11.79c1.71,0,2.98,1.99,2.84,4.38l-2.45,43.04c-.07,1.2-1.07,2.16-2.24,2.16Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstadoParcial);
export default __webpack_public_path__ + "static/media/EstadoParcial.72e1d4531e57df267fa3d857c8d9eb78.svg";
export { ForwardRef as ReactComponent };